<div class="label" [ngClass]="{ relativePosition: relativePosition }">
  <div *ngFor="let label of labels" [ngClass]="['chip-color-' + label.color]" class="mb-1" [class.small]="smallLabels">
    <div class="flex flex-row items-center justify-start">
      <ion-icon *ngIf="label.icon" [name]="label.icon"></ion-icon>
      &nbsp;
      <div class="show-ellipsis">
        <span>{{ label.label === 'descuento' ? discountLabel : label.info }}</span>
      </div>
    </div>
  </div>
</div>
